import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseIconKm } from 'assets/images/autos/icon-km.svg';

export const Container = styled.section`
  padding: 0;
`;

export const ContainerRules = styled.div`
  padding: 16px;
`;

interface HeaderProps {
  $details: boolean;
}
export const Header: any = styled.div<HeaderProps>`
  padding-top: ${({ $details }) => ($details ? '16px' : '8px')};
`;

Header.Image = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

Header.Logo = styled.div`
  width: 96px;
  height: 25px;
  position: absolute;
  top: 0;
  left: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top left;
`;

Header.Title = styled.h3`
  color: ${ColorPalette.HEX.PineTree};
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.83px;
`;

Header.Subtitle = styled.h6`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  margin-bottom: 10px;
`;

export const Section: any = styled.div`
  border-bottom: 0.5px solid ${ColorPalette.HEX.Platinum2};
  padding: 16px;
`;

Section.Sub = styled.div`
  padding: 0 16px;
`;

Section.Last = styled.div`
  padding: 0 16px 100px;
`;

export const Comments = styled.div`
  line-height: 1.3em;
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};

  b {
    font-weight: 600;
    font-size: 14px;
    color: ${ColorPalette.HEX.OuterSpace};
  }
  ul li {
    margin: 0.5em 16px;
  }
`;

export const IconKm = styled(BaseIconKm)`
  color: ${ColorPalette.HEX.PineTree};
  width: 24px;
  height: 24px;
`;
